import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtUser, MtTask } from "server/models"
import {
    StoreType,
    setNotAssignedTaskObserverSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
} from "client/components"

const Columns = (task: MtTask) => {
    const selected = useSelector((state: StoreType) => state.taskObserver.notAssignedUsers.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectUser = (user: MtUser) => {
        let selectedCopy
        if (selected && selected.includes(user.id)) {
            selectedCopy = selected.filter((id) => (id !== user.id))
        } else {
            selectedCopy = selected ? selected.slice() : []
            selectedCopy.push(user.id)
        }
        dispatch(setNotAssignedTaskObserverSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectUser,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "250px",
            formatter: (user: MtUser) => (
                <UserIcon
                    user={user}
                    size="sm"
                    projectId={task.projectId}
                    showProjectStatus
                />
            ),
            onClick: selectUser,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => false,
        },
    ]

    return columns
}
export default Columns
